import { useEffect, useRef, useState } from "react";

type CountdownCallback = () => void;

interface UseCountdownTimerReturn {
  timeLeft: number;
  isTimerRunning: boolean;
  start: (duration: number, onComplete?: CountdownCallback) => void;
  reset: () => void;
}

export function useCountdownTimer(): UseCountdownTimerReturn {
  const [timeLeft, setTimeLeft] = useState<number>(0);
  const [isTimerRunning, setIsRunning] = useState<boolean>(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const start = (duration: number, onComplete?: CountdownCallback) => {
    setTimeLeft(duration);
    setIsRunning(true);

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    intervalRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(intervalRef.current!);
          setIsRunning(false);
          onComplete?.();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const reset = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    setIsRunning(false);
    setTimeLeft(0);
  };

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  return { timeLeft, isTimerRunning, start, reset };
}
